module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h1', [_vm._v("LIST OF PHOTOS")]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2",
    staticStyle: {
      "margin-top": "50pt"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic1"
    }
  }, [_vm._v("Photo 1 Three-Finger Front, Top View")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic2"
    }
  }, [_vm._v("Photo 2 Three-Finger Front, Bottom View")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic3"
    }
  }, [_vm._v("Photo 3 Three-Finger Front, Side View")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic4"
    }
  }, [_vm._v("Photo 4 Yuri’s 3-Finger Diagonal Grip, Side View")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic5"
    }
  }, [_vm._v("Photo 5 2-Finger O-Ring, Top View")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic6"
    }
  }, [_vm._v("Photo 6 2-Finger O-Ring, Bottom View")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic7"
    }
  }, [_vm._v("Photo 7 Pincer Grip (Thumb and Middle Finger)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic8"
    }
  }, [_vm._v("Photo 8 Pincer Grip Variation (Thumb and Middle Finger)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_chap3#pic9"
    }
  }, [_vm._v("Photo 9 5-Finger Pincer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap5#pic10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo 10 Dice Barrel With Level")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7435097c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_listofphotos.vue
// module id = 75
// module chunks = 0